import "./AppPage.scss";
import { useNavigate } from "react-router-dom";
import appImg from "../../assets/images/ic_appLogo.svg";
import img1 from "../../assets/images/Login-Desktop.svg";
import img2 from "../../assets/images/List option.svg";
import img3 from "../../assets/images/Generated-answers.svg";
import LaunchImg from "../../assets/images/RocketLaunch.svg";
import VideoImg from "../../assets/images/Video.svg";
import releaseIcon from "../../assets/images/CalendarBlank.svg";
import versionIcon from "../../assets/images/GitFork.svg";
import updateIcon from "../../assets/images/ArrowsClockwise.svg";
import ArrowBack from "../../assets/images/arrowBack.svg";
import brochureIcon from "../../assets/images/DownloadSimple.svg";

const tags = ["Mobile App", "Design", "Mobile App", "Design"];

const screenshots = [img1, img2, img3];



const features = [
  "Production ready: Ubuntu is the leading Linux in the public cloud with > 50% of Linux workloads",
  "Developer friendly: Ubuntu is the #1 Linux for developers offering the latest library and tools to innovate with the latest technologies",
  "No mandatory licenses: Ubuntu Server is freely available, with no mandatory licenses and unlimited VMs",
  "Non-stop security: Canonical publishes images on a daily basis, ensuring security is built-in from the moment an instance launches",
  "Optimized performance: optimized kernel, with improved boot speed, outstanding runtime performance and advanced device support",
  "Portability: Ubuntu is available in all regions with content mirrors to avoid the  need to go across regions or out to the Internet for updates",
  "5-year security maintenance: Ubuntu Server 22.04 LTS provides security maintenance until June 2027",
];

type AppPageProps = {
    title: string;
};
  
  const AppPage = ({ title }: AppPageProps) =>{
  const navigate = useNavigate();
  return (
    <div className="appPage">
      <div className="appPage__back" 
         onClick={() => navigate("/landing")}>
        <img src={ArrowBack} alt="Back"/>
        <span>Back to all apps</span>
      </div>

      <div className="appPage__container">

        <aside className="appPage__sidebar">

          <img src={appImg} alt="App logo" className="appPage__logo" />
        <div>
          <button className="appPage__btn appPage__btn--launch">
            Launch
            <img src={LaunchImg} alt="Launch"/>
          </button>

          <button className="appPage__btn appPage__btn--demo" >
            Video Demo
            <img src={VideoImg} alt="Play"/>
          </button>
            <div className="brochure">
                <span>Brochure</span>
                <img src={brochureIcon} alt="brochure icon" />
            </div>
        </div>
        </aside>
        <main className="appPage__content">

          <h1 className="appPage__title">
            Accellor GenAI for Healthcare
          </h1>
          <div className="appPage__tags">
            {tags.map((tag, index) => (
              <button key={index}>{tag}</button>
            ))}
          </div>

          <div className="appPage__meta">

          <div className="metaItem">
            <img src={releaseIcon} alt="release icon" className="icon" />
                <div>
                <h6>Released</h6>
                <span>20 March 2026</span>
                </div>
            </div>

            <div className="metaItem">
                <img src={versionIcon} alt="version icon" className="icon" />
                <div>
                <h6>Version</h6>
                <span>12.6.02</span>
                </div>
            </div>

            <div className="metaItem">
                <img src={updateIcon} alt="update icon" className="icon" />
                <div>
                <h6>Last Updated</h6>
                <span>3rd March, 2026</span>
                </div>
            </div>

          </div>

          <div className="appPage__divider"></div>
          <h3 className="appPage__sectionTitle">
            App Screenshots
          </h3>

          <div className="appPage__screenshots">
            {screenshots.map((img, index) => (
              <img key={index} src={img} alt="app screenshot" />
            ))}
          </div>

          <p>
          Ubuntu Server delivers services reliably,  predictably and economically. It is the perfect base on which to build  your instances. Ubuntu is the world’s most popular Linux for cloud  environments and is suitable for small to large-scale Linux operations.  Ubuntu Server for Azure is designed by Canonical (the publishers of  Ubuntu) and optimized for Azure. For more information, see Ubuntu on Azure.
          Ubuntu is free and will always be, with the option to access  additional security, management tools and technical support when you  need it through additional commercial offerings from Canonical (for  example Ubuntu Pro 22.04 LTS).
          </p>
          <p>
          This offer supports both x86 and arm64 instances.
          </p>
          <div className="appPage__description">

            <p className="featureTitle">
              Why developers and devops choose Ubuntu Server for Azure
            </p>

            <ul className="featureList">
              {features.map((item, index) => (
                <li key={index}>{item}</li>
              ))}
            </ul>

          </div>

          <p>
          For professional  environments or applications where additional security  and compliance would be beneficial, or where you might want to continue  using the environment beyond June 2027, Canonical recommends Ubuntu Pro 22.04 LTS.
          </p>

        </main>

      </div>
    </div>
  );
};

export default AppPage;